<template>
  <v-navigation-drawer absolute temporary app v-model="drawer">
    <v-card dark flat class="primary elevation-4">
      <v-card-title primary-title class="pa-0 pt-2">
        <v-list dark class="primary pa-0">
          <v-list-tile avatar>
            <v-list-tile-avatar v-if="currentUser.photoURL">
              <img :src="currentUser.photoURL" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ currentUser.displayName || t('Nobody signed in') }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ currentUser.email }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-title>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat dark @click="signOut" v-if="authenticated">{{ t('Sign out') }}</v-btn>
      </v-card-actions>

      <v-divider light></v-divider>

      <v-card-actions>
        <span style="margin-left: 12px">{{ t('Cell') }}: {{ cellDesc }}</span>
      </v-card-actions>
    </v-card>

    <v-list dense>
      <v-list-tile v-for="item in drawerItems" :key="item.path" :to="item.path">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>{{ item.name }}</v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-card flat class="secondary mt-5">
      <v-card-title primary-title class="pt-1 pb-1"> {{ t('Version') }}: {{ version }} </v-card-title>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer
      },
      set(value) {
        this.$store.commit('drawer', value)
      },
    },
    cellDesc() {
      return this.$store.getters['cell/cellDesc'](this.cell)
    },
    version() {
      return this.$store.state.config.version
    },
    ...mapGetters(['authenticated', 'currentUser', 'cell', 'drawerItems']),
  },
  methods: {
    ...mapActions(['signOut']),
  },
}
</script>
